import React, { useCallback, useContext, useEffect, useState } from "react";
import style from "./Sendinput.module.css";
import { IoFileTrayStackedSharp } from "react-icons/io5";
import { BsEmojiSmile, BsSendFill, BsCardImage } from "react-icons/bs";
import { Chatcontext } from "../context/Chatcontext";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { db, storage } from "../../firebase/config";
import { v4 as uuid } from "uuid";
import {
  Timestamp,
  arrayUnion,
  doc,
  getDoc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { Authcontext } from "../context/Authcontext";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import Overlay from "../admin/Overlay";
import { PiFilePdfBold } from "react-icons/pi";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
const Sendinput = (props) => {
  const [text, setText] = useState("");
  const [file, setFile] = useState(null);
  const [fileurl, setFileurl] = useState([]);
  const [showemoji, setSowemoji] = useState(false);
  const { currentuser, usertype } = useContext(Authcontext);
  const chat = useContext(Chatcontext);
  const [progress, setProgress] = useState(0);
  const [progoverlay, setprogoverlay] = useState(false);
  const [sendoverlay, setSendoverlay] = useState(false);
  const [roomUser, setRoomUser] = useState();
  const chatcontext = useContext(Chatcontext);
  const enterpress = (e) => {
    e.code === "Enter" && handlesend();
  };
  // console.log(f)
  const getRoomUser = async () => {
    const docRef = doc(db, "roomuser", chatcontext?.chatid);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setRoomUser(docSnap?.data()?.users);
    } else {
      // docSnap.data() will be undefined in this case
      console.log("No such document!");
    //   toast.warning("There is some thing went Wrong")
    }
  };
  useEffect(() => {
    getRoomUser();
  }, [chatcontext.chatid]);
  const handlesend = async () => {
    setSendoverlay(false);
    if (file) {
      file.map((f) => {
        const type = f?.type.includes("image")
          ? "image"
          : f?.type.includes("video")
          ? "video"
          : f?.type.includes("pdf")
          ? "file"
          : "file";
        const storageRef = ref(storage, f.name);
        const uploadTask = uploadBytesResumable(storageRef, f);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            const progress =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setProgress(progress);
            switch (snapshot.state) {
              case "paused":
                toast.success("Upload is paused");
                setprogoverlay(false);
                break;
              case "running":
                setprogoverlay(true);
                break;
            }
          },
          (error) => {},
          async () => {
            await getDownloadURL(uploadTask.snapshot.ref).then(
              async (downloadURL) => {
                await updateDoc(doc(db, "messages", chat.chatid), {
                  message: arrayUnion({
                    id: uuid(),
                    text: text,
                    type: type,
                    senderid: currentuser.uid,
                    sendername: currentuser.displayname,
                    senderimage: currentuser.photoURL,
                    date: Timestamp.now(),
                    file: downloadURL,
                    status:
                      usertype === "admin" ||
                      usertype === "client" ||
                      usertype === "supervisor"
                        ? "approved"
                        : "pending",
                    chatid: chat.chatid,
                  }),
                });
                setText("");
                setFile(null);
                setprogoverlay(false);
                toast.success(
                  "انتظر حتى تتم الموافقة علي الصوره حتي تظهر ف الدردشه"
                );
              }
            );
          }
        );
      });
    } else if (text) {
      await updateDoc(doc(db, "messages", chat.chatid), {
        message: arrayUnion({
          id: uuid(),
          text: text,
          senderid: currentuser?.uid,
          senderimage: currentuser?.photoURL,
          chatid: chat?.chatid,
          status: "approved",
          date: Timestamp.now(),
          sendername: currentuser?.displayname,
          type: "text",
          file: null,
        }),
      });
      setText("");
    }
    async function increaseUnreadMessages() {
      const updatedUsers = roomUser.map((user) => {
        if (user.user_id !== currentuser?.uid) {
          return { ...user, un_read_message: +user.un_read_message + 1 };
        }
        return user;
      });
      await updateDoc(doc(db, "roomuser", chat.chatid), {
        lastmessage: text,
        users: updatedUsers,
        date: serverTimestamp(),
      });
      getRoomUser()
    }
    increaseUnreadMessages();
    // await messaging.send({ to: `/topics/${chat.chatid}`, notification: { title: 'Hello', body: 'This is a test message.' } });
  };

  useEffect(() => {
    if (file) {
      setSendoverlay(true);
    }
  }, [file]);
  const handelcancel = () => {
    setFile(null);
    setFileurl("");
    setSendoverlay(false);
  };
  const changefilehandler = (e) => {
    const demo = [];
    const demourl = [];
    for (let i = 0; i < e.target.files.length; i++) {
      demo.push(e.target.files[i]);
      demourl.push(URL.createObjectURL(e.target.files[i]));
    }
    setFile(demo);
    setFileurl(demourl);
  };
  return (
    <>
      {sendoverlay && (
        <Overlay>
          <div className={style.confirmcard}>
            <Carousel width={500} showThumbs={false}>
              {file.map((f) => {
                return (
                  <>
                    {f?.type?.includes("image") && (
                      <>
                        {" "}
                        <div
                          style={{
                            width: "400px",
                            height: "400px",
                            margin: "auto",
                          }}>
                          <img
                            src={URL.createObjectURL(f)}
                            style={{ maxWidth: "100%", maxHeight: "100%" }}
                          />
                        </div>
                      </>
                    )}
                    {f?.type?.includes("video") && (
                      <video width="500px" height="300px" controls>
                        <source src={fileurl} type="video/mp4" />
                      </video>
                    )}
                    {f?.type !== "image" || f?.type !== "video" ? (
                      <>
                        <IoFileTrayStackedSharp color="black" size={160} />
                        <br />
                        <span>{file[0].name}</span>
                        <br />
                      </>
                    ) : null}
                  </>
                );
              })}
            </Carousel>
            <div className={style.btns}>
              <button onClick={handlesend}>ارسال</button>
              <button onClick={handelcancel}>الغاء</button>
            </div>
          </div>
        </Overlay>
      )}
      {progoverlay && (
        <Overlay>
          <CircularProgressbar
            value={progress}
            text={`${Math.ceil(progress)}%`}
          />
        </Overlay>
      )}
      <div
        style={{ borderTop: props.bordercolor }}
        className={style.sendinputcontainer}>
        <ToastContainer />
        <BsSendFill
          style={{ cursor: "pointer" }}
          onClick={handlesend}
          size={30}
        />
        <input
          style={{ color: props.color }}
          type="text"
          onKeyDown={enterpress}
          onChange={(e) => setText(e.target.value)}
          value={text}
        />
        <div className={style.sendingtool}>
          <input
            type="file"
            multiple
            style={{ display: "none" }}
            id="files"
            accept="*/*"
            onChange={changefilehandler}
          />
          <BsEmojiSmile
            size={25}
            onClick={() => setSowemoji(!showemoji)}
            style={{ cursor: "pointer" }}
          />
          <label htmlFor="files" style={{ cursor: "pointer" }}>
            <BsCardImage size={30} />
          </label>
        </div>
        {showemoji && (
          <div className={style.picker}>
            <Picker
              data={data}
              onEmojiSelect={(e) => setText(text + e.native)}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default Sendinput;
